<template>
  <base-layout
    :readOnly="readOnly"
    :value="value"
    :text-align="textAlign"
    :label-width="labelWidth"
    :is-require="isRequire"
    :label="label"
    :is-dipatch="isDipatch"
  >
    <el-time-picker
      v-model="inputValue"
      clearable
      slot="control"
      :disabled="disabled"
      @change="handleEmitValue"
    ></el-time-picker>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { handleEmitValue, dateTimer } from "./../props-config";
export default {
  name: "base-time-picker",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        const t = this.$utils.formatTime(val);
        this.$emit("input", t);
      }
    }
  },
  props: {
    ...dateTimer,
    // year/month/date/week/ datetime/datetimerange/daterange
    type: {
      type: String,
      default: "date"
    },
    // '{y}/{m}/{d} {h}:{i}:{s}' 返回的时间格式
    valueFormat: {
      type: String,
      default: "{y}-{m}-{d}"
    },
    format: {
      type: String,
      default: 'HH:mm:ss'
    }
  },
  mounted() {},
  methods: {
    handleEmitValue
  },
  data() {
    return {
      isFirst: true
    };
  }
};
</script>